<template>
    <div>
      <h1>仪表盘</h1>
      <p>这是一个需要登录后访问的页面。</p>
    </div>
  </template>
  